import React from "react";
import styled from "styled-components";

import { TableCell } from "../../UI/TableCell";
import { TableHead } from "../../UI/TableHead";
import { TableRow } from "../../UI/TableRow";
import { RetainAnswerHelpTooltip } from "../RetainAnswerHelpTooltip";


const TableHeadWrapper = styled.div`
  position: absolute;
  right: 160px;
`;

const StyledRightWrapper= styled.div`
  text-align: right;
  top: -10px;
  position: relative;
`;

interface IProps {
  showTagColumn?: any;
}

export const FreeTextQuestionsTableHead: React.FC<IProps> = (props) => (
  <TableHead secondary>
    <TableRow>
      <TableCell />
      <TableCell>Question</TableCell>
      <TableCell>Placeholder</TableCell>
      <TableCell>Disclaimer</TableCell>
      {props.showTagColumn && <TableCell>Tag</TableCell>}
      <TableCell>
        <TableHeadWrapper>
          <StyledRightWrapper>
            <RetainAnswerHelpTooltip>
              Retain Answer
            </RetainAnswerHelpTooltip>
          </StyledRightWrapper>
        </TableHeadWrapper>
      </TableCell>
    </TableRow>
  </TableHead>
);
